const chartColorPalette: string[] = [
  // Primary brand colors (Relif)
  '#6499e9', // main blue
  '#15163a', // dark navy
  '#f9cf0c', // brand yellow
  // Complementary colors with better differentiation (colorblind-friendly)
  '#009e73', // green
  '#d55e00', // orange/red
  '#cc79a7', // magenta
  '#56b4e9', // light blue
  '#e69f00', // orange
  '#0072b2', // strong blue
  '#e51e10', // red
  '#7f3c8d', // purple
  '#999999', // neutral gray
];

export default chartColorPalette;
